import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';

const SelectWithInput = ({
    options = [],
    label,
    onChange,
    placeholder,
    selected,
    className,
    dataE2e,
    required = false,
}) => {
    return (
        <div className={`custom-autocomplete ${className || 'mt-6'}`}>
            <label data-e2e={label} className="block text-sm font-medium text-balanceCard-manage mb-2 uppercase tracking-wide text-left w-full">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <Autocomplete
                data-e2e={selected}
                defaultValue={selected}
                onChange={onChange}
                options={options}
                ListboxProps={{
                    sx: {
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: 'transparent',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        background: '#80808080',
                        borderRadius: '4px',
                      },
                      scrollbarWidth: 'thin',
                      scrollbarColor: 'black',
                    },
                  }}
                slotProps={{
                    paper: {
                      className: `
                        dark:bg-[#26272B] !text-text 
                        dark:[&_.MuiAutocomplete-option:hover]:!bg-[#3f3f46]
                      `,
                    },
                  }}
                renderInput={params => (
                    <TextField
                        data-e2e={`${dataE2e}-${placeholder?.toUpperCase()}`}
                        className="w-full bg-card-bg rounded-md text-sm font-medium h-12"
                        {...params}
                        hiddenLabel
                        placeholder={placeholder}
                        required={required}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                            '& .MuiSvgIcon-root': {
                                color: 'var(--color-text)',
                            },
                            '& .MuiInputBase-input': {
                                color: 'var(--color-text)',
                                paddingTop: '5px !important',
                            },
                            '& .MuiInputBase-input::placeholder': {
                                color: 'var(--color-text)',
                                textTransform: 'uppercase',
                                fontSize: '0.875rem',
                                lineHeight: '1.25rem',
                            },
                        }}
                    />
                )}
                isOptionEqualToValue={(option, value) => option === value}
            />
        </div>
    );
};

SelectWithInput.propTypes = {
    options: PropTypes.array,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
};

export default SelectWithInput;
